import { render, staticRenderFns } from "./NovaEscola.vue?vue&type=template&id=45a11c42&"
import script from "./NovaEscola.vue?vue&type=script&lang=js&"
export * from "./NovaEscola.vue?vue&type=script&lang=js&"
import style0 from "./NovaEscola.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports